import {DOCUMENT__LOADED_DETAILS} from 'app/AppConstants';

export default (state = {documents: {}}, action) => {
  switch (action.type) {
    case DOCUMENT__LOADED_DETAILS:
      return {
        documents: {
          ...state.documents,
          [action.payload.dataFileId]: action.payload,
        },
      };
    default:
      return state;
  }
};
